export default __webpack_public_path__ + "static/media/9_16-clip-web.a0e4e909.png";